import { render, staticRenderFns } from "./AlcorFilters.vue?vue&type=template&id=34b06235&scoped=true&lang=pug"
import script from "./AlcorFilters.vue?vue&type=script&lang=js"
export * from "./AlcorFilters.vue?vue&type=script&lang=js"
import style0 from "./AlcorFilters.vue?vue&type=style&index=0&id=34b06235&prod&lang=scss"
import style1 from "./AlcorFilters.vue?vue&type=style&index=1&id=34b06235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b06235",
  null
  
)

export default component.exports